<template>
  <v-data-table
    id="offersGroupTable"
    v-model="selected"
    calculate-widths
    disable-pagination
    :expanded.sync="expanded"
    fixed-header
    :headers="offersHeaders"
    hide-default-footer
    item-key="unigueKey"
    :items.sync="group.items"
    :multi-sort="false"
    :no-data-text="$t('Tenders.NoData')"
    :no-results-text="$t('Tenders.NoData')"
    :show-select="!without_select"
    @click:row="expand">
    <template #[nameColumnKey]="{ item }">
      <div
        v-if="groupType === 'byLot'"
        class="lotTitle flex flex-wrap"
        data-qa="offer-title">
        <BidderIsWinner
          v-if="item.selectedBid"
          class="mr-2 mt-1"
          :color="item.hasPositionNotSelectedBid ? '#ddd309' : '#7DE199'"/>
        <div
          :class="{'secondary__green_not_active--text': item.bidStatus == 'DRAFT'}"
          data-qa="offer-name">
          {{ item.lotGroupTitle }}
        </div>
      </div>
      <BidderInfoCell
        v-else
        :item="item"
        :only-review="only_review"
        :tender="tender"
        @showRequirements="showRequirements"/>
    </template>
    <template #[`item.summ`]="{ item }">
      <sPopover
        :disabled="!item.bestPrice"
        trigger="hover"
        width="200">
        <div
          class="black--text h8-text text-start px-2 py-2"
          data-qa="group-price-tooltip">
          {{ $t('Tenders.BidPriceTooltipText') }}
        </div>
        <div
          slot="reference"
          :class="{'secondary__green_not_active--text': item.bidStatus == 'DRAFT', ' best-price-chip secondary__green_approved px-2 rounded-lg': item.bestPrice && item.bidStatus !== 'DRAFT'}"
          data-qa="currency-price"
          style="max-width: fit-content;">
          {{ $n(item.currencySumm, 'decimal') }}
          {{ item.currencyTitle }}
        </div>
      </sPopover>
      <CurrencyConversionTooltip
        v-if="item.price"
        :currency="item.currencyTitle"
        :current-id="item.currencyId"
        :price="item.currencySumm"
        :transform="true"/>
    </template>
    <template #[`item.totalCost`]="{ item }">
      <div
        data-qa="total-cost"
        style="max-width: fit-content;">
        {{ $n(item.totalCost, 'decimal') }}
        {{ item.currencyTitle }}
      </div>
      <CurrencyConversionTooltip
        v-if="item.price"
        :currency="item.currencyTitle"
        :current-id="item.currencyId"
        :price="item.totalCost"
        :transform="true"/>
    </template>
    <template #[`item.status`]="{ item }">
      <StatusChip
        v-if="item.prequalification && item.prequalification.status"
        key-name="status"
        :name="$t('Tenders.prequalification.' + item.prequalification.status)"
        :status="item.prequalification"/>
    </template>
    <template #[`item.statusReduction`]="{ item }">
      <StatusChip
        v-if="item.bidDecisionAttribute !== 'DEFAULT'"
        :color="item.bidDecisionAttribute === 'DISQUALIFIED' ? 'var(--color-error)' : (item.bidDecisionAttribute === 'WINNER' ? 'var(--color-warning)' : 'var(--color-warning)')"
        key-name="status-reduction"
        :name="$t('Tenders.stateBidReduction.' + item.bidDecisionAttribute)"
        :status="item.prequalification"
        text-color="var(--text-color)"/>
    </template>
    <template #[`item.attachmentCount`]="{ item }">
      <sTooltip
        class="item"
        placement="top-end">
        <div slot="content">
          {{ $t('Tenders.bidAttachments') }}
        </div>
        <IconCount
          class="mt-auto mr-0"
          :count="item.attachmentCount"
          icon="draft"
          :icon-color="!item.attachmentCount ? 'grey': ''"
          :text-class="{ 'grey--text': !item.attachmentCount }"/>
      </sTooltip>
    </template>
    <template #expanded-item="{ item }">
      <td
        :colspan="offersHeaders.length">
        <OffersParticipantGroupSubTable
          :key="group.id"
          class="group-sub-table"
          :contranct-props="contranctProps"
          :critery-card="criteryCard"
          :currencies="currencies"
          :item="item"
          :mode="`${mode ? mode + '-' : ''}lotGroups`"
          :only_review="only_review"
          :tender="tender"/>
        <OffersParticipantGroupTableDetails
          :item="item"
          :tender="tender"/>
      </td>
    </template>
    <template #[`body.append`]>
      <OfferRequirementsInfo
        v-if="groupType === 'bySupplier'"
        :requirement.sync="requirementsModalInfo"/>
    </template>
  </v-data-table>
</template>
<script>
import IconCount from 'components/common/elements/IconCount.vue'
import BidderIsWinner from 'components/tenders/BidderIsWinner.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import BidderInfoCell from 'components/tenders/tender page/offersGroups/BidderInfoCell.vue'
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'
import OfferRequirementsInfo from 'components/tenders/tender page/tender tabs/OfferRequirementsInfo.vue'
import OffersParticipantGroupSubTable from 'components/tenders/tender page/offersGroups/OffersParticipantGroupSubTable.vue'
import OffersParticipantGroupTableDetails from 'components/tenders/tender page/offersGroups/OffersParticipantGroupTableDetails.vue'

import tableMixin from 'mixins/tableMixin'
import tableSelectionMixin from 'mixins/tableSelectionMixin'

export default {
  name: 'offersGroupTable',
  mixins: [
    tableMixin,
    tableSelectionMixin,
  ],
  data() {
    return {
      offersHeaders: [],
      expanded: [],
      requirementsModalInfo: null,
    }
  },
  props: {
    /*
      тільки перегляд - без редагування і переходу
    */
    only_review: {
      type: Boolean,
      default: false
    },
    criteryCard: Object,
    tender: Object,
    without_select: Boolean,
    contranctProps: {
      type: Object
    },
    currencies: {
      type: Array,
      default: () => []
    },
    /**
     * Место где используется таблица.
     * На текущий момент, нужно только для правильной обработки результата запроса по изменению цены
     */
    mode: {
      type: String
    },
    /**
     * byLot — рядки таблиці є лотами (групування по учаснику)
     * bySupplier — рядки таблиці є постачальниками (групування по лоту)
     */
    groupType: {
      type: String,
      default: 'byLot',
      validator: v => ['byLot', 'bySupplier', 'byWinners'].includes(v),
    },
  },
  computed: {
    nameColumnKey() {
      if (this.groupType === 'byLot') {
        return 'item.lotGroupTitle'
      }
      return 'item.name'
    },
  },
  methods: {
    showRequirements(requirement) {
      this.requirementsModalInfo = requirement
    },
    expand(val) {
      if (this.expanded.find(el => el.unigueKey == val.unigueKey)) {
        this.expanded = this.expanded.filter(el => el.unigueKey != val.unigueKey)
      } else {
        this.expanded.push(val)
      }
    },
    createHeader() {
      const nameColumn = this.groupType === 'byLot'
        ? { text: this.$t('Назва лоту'), value: 'lotGroupTitle', coef_width: '3' }
        : { text: 'Постачальник', value: 'name', coef_width: '3', sortable: false  }

      let headers = [
        { text: '', value: 'data-table-select', width: '20px' },
        nameColumn,
      ]

      if (this.groupType === 'byWinners') {
        headers.push({ text: 'Лот', value: 'lotGroupTitle', coef_width: '1' })
      }

      headers.push({ text: this.$t('Tenders.TotalPriceShort'), value: 'summ', coef_width: '1.2' })
      headers.push({ text: this.$t('Tenders.TotalCostShort'), value: 'totalCost', coef_width: '1.2' })

      if (this.$can('is', 'tenderProposalShowIp') && this.mode !== 'history') {
        headers.push({ text: 'IP', value: 'ipAddress', width: '130px' })
      }
      headers.push({ text: '', value: 'attachmentCount', width: '40px', sortable: false })

      this._handleSelectColumn(headers)
      this.$_getHeadersWidthByCoef(headers)

      headers.push({ text: '', value: 'last', width: '1px' })
      this.offersHeaders = headers
    },
    _handleSelectColumn(headers) {
      if (this.without_select) {
        headers[0].value = ''
      }
    },
  },
  watch: {
    tender: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val?.tenderId !== old?.tenderId) {
          this.createHeader()
        }
      }
    },
  },
  components: {
    IconCount,
    StatusChip,
    BidderIsWinner,
    BidderInfoCell,
    OfferRequirementsInfo,
    CurrencyConversionTooltip,
    OffersParticipantGroupSubTable,
    OffersParticipantGroupTableDetails,
  },
}
</script>
<style lang="scss">
#offersGroupTable tr {
  cursor: pointer;
  .group-sub-table {
    background: #D6EDEB;
    margin: -10px -13px;
    padding: 0 0 15px 10px;
  }
}
</style>
